import { render } from "./VerfyEmail.vue?vue&type=template&id=188d64bb&scoped=true"
import script from "./VerfyEmail.vue?vue&type=script&lang=js"
export * from "./VerfyEmail.vue?vue&type=script&lang=js"

import "./VerfyEmail.vue?vue&type=style&index=0&id=188d64bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188d64bb"]])

export default __exports__